import React, { ReactNode } from "react";

import { LoadingSpinner } from "../loaders/LoadingSpinner";
import styles from "./Button.module.scss";

export interface Props {
  id?: string;
  children: ReactNode;
  disabled?: boolean;
  loading?: boolean;
  leading?: ReactNode;
  trailing?: ReactNode;
  onClick: () => void | Promise<void>;
  type?: "primary" | "link" | "outlined";
}

export const Button = ({ id, children, disabled, loading, leading, trailing, onClick, type }: Props) => (
  <button
    id={id}
    disabled={disabled || loading}
    className={`${styles.button_container} ${type ? styles[type] : ""} ${loading ? styles.button_loading : ""}`}
    onClick={onClick}
    type="button"
  >
    <span>
      <span className={styles.leading}>
        {loading && !trailing && <LoadingSpinner />}
        {!loading && leading}
      </span>
      {children}
      <span className={styles.trailing}>
        {!loading && trailing} {loading && trailing && <LoadingSpinner />}
      </span>
    </span>
  </button>
);
